import React, { useState } from "react";
import "./style.scss";
import crossIcon from "../../../assets/icons/cross.svg";
import profileImg from "../../../assets/icons/user_profile_pic.svg";
import copyIcon from "../../../assets/icons/copy.svg";
import moment from "moment";
import { FormatUSD, formatDateInTimeZone } from "../../../utils/helpers/string";
import toast from "react-hot-toast";
import CopyToClipboard from "react-copy-to-clipboard";
import SwitchPlatformModal from "./SwitchPlatformModal";

function DashboardModal({ isOpen, onClose, item }) {
  const [isSwitchModalOpen, setIsSwitchModalOpen] = useState(false);

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2 className="component-heading">Account Info</h2>

          <img onClick={onClose} src={crossIcon} alt="" />
        </div>

        <div className="modal-profile-details">
          <img src={profileImg} alt="" />
          <div className="name_switch_btn">
            <div>
              <p>{item?.account_name}</p>
              <span>{item?.phase}</span>
            </div>
            {item?.trading_platform === "ProjectX/Quantower" && (
              <button
                style={{
                  padding: "8px 16px",
                  borderRadius: "4px",
                  background: "rgba(255, 255, 255, 0.05)",
                  color: "#FFF",
                  border: "none",
                  cursor: "pointer",
                  fontSize: "14px",
                  fontWeight: 500
                }}
                onMouseOver={(e) => e.target.style.background = "rgba(255, 255, 255, 0.1)"}
                onMouseOut={(e) => e.target.style.background = "rgba(255, 255, 255, 0.05)"}
                onClick={() => setIsSwitchModalOpen(true)}
              >
                Switch Platform
              </button>
            )}
          </div>
        </div>
        <div className="modal-content">
          <div className="modal-item">
            <span>Type</span>
            <p>{item?.account_type}</p>
          </div>
          {/* <div className="modal-item">
            <span>Leverage </span>
            <p>N/A</p>
          </div>

          <div className="modal-item">
            <span>Group</span>
            <p>N/A</p>
          </div> */}
          <div className="modal-item">
            <span>Starting Balance</span>
            <p>{item?.starting_balance}</p>
          </div>

          <div className="modal-item">
            <span>User Name</span>

            <div>
              <p>{item?.trading_platform?.toLowerCase()?.includes("wealthchart") ? "N/A" : item?.user_name} </p>
              {!(item?.trading_platform?.toLowerCase()?.includes("wealthchart")) && (
                <CopyToClipboard
                  text={item?.user_name}
                  onCopy={() =>
                    item?.user_name &&
                    toast.success("User Name copied!")
                  }
                >
                  <p className="table_copy_button" style={{ cursor: "pointer" }}>
                    <img src={copyIcon} alt="" />
                  </p>
                </CopyToClipboard>
              )}{" "}
            </div>
          </div>
          <div className="modal-item">
            <span>Password </span>
            <div>
              <p>{item?.trading_platform?.toLowerCase()?.includes("wealthchart") ? "N/A" : item?.password}</p>
              {!(item?.trading_platform?.toLowerCase()?.includes("wealthchart")) && (
                <CopyToClipboard
                  text={item?.password}
                  onCopy={() =>
                    item?.password && toast.success("Password copied!")
                  }
                >
                  <p className="table_copy_button" style={{ cursor: "pointer" }}>
                    <img src={copyIcon} alt="" />
                  </p>
                </CopyToClipboard>
              )}{" "}
            </div>{" "}
          </div>

          <div className="modal-item">
            <span>Account start date</span>
            <p>{moment(item?.start_date).format("DD-MM-YYYY")}</p>
          </div>

         {item?.account_type?.toLowerCase()!=="qualified"&& <div className="modal-item">
            <span>Account expiry date</span>
            <p>{moment(item?.expiry_date).format("DD-MM-YYYY")}</p>
          </div>}
        </div>
        {isSwitchModalOpen && (
          <SwitchPlatformModal
            isOpen={isSwitchModalOpen}
            onClose={() => setIsSwitchModalOpen(false)}
            item={item}
          />
        )}
      </div>
    </div>
  );
}

export default DashboardModal;
